var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1871 6.15625H2.81213C2.55325 6.15625 2.34338 6.36612 2.34338 6.625V13.1875C2.34338 13.4464 2.55325 13.6562 2.81213 13.6562H12.1871C12.446 13.6562 12.6559 13.4464 12.6559 13.1875V6.625C12.6559 6.36612 12.446 6.15625 12.1871 6.15625Z",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39026 6.15625V4.04688C5.39026 3.48743 5.6125 2.95091 6.00808 2.55532C6.40367 2.15974 6.94019 1.9375 7.49963 1.9375C8.05907 1.9375 8.5956 2.15974 8.99119 2.55532C9.38677 2.95091 9.60901 3.48743 9.60901 4.04688V6.15625",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSimple);
export default __webpack_public_path__ + "static/media/LockSimple.1f1d688a166465e02b4a0de34167693a.svg";
export { ForwardRef as ReactComponent };